const e = Object.freeze(["requested_by_customer", "issue_with_item_sold", "fraudulent", "duplicate", "other"]);
export {
  e as REFUND_REASONS
};
